<template>
	<Transition
		name="hotspot"
		enter-active-class="transition-all duration-400 ease-[cubic-bezier(0.34,1.2,0.64,1)]"
		leave-active-class="transition-all duration-300 ease-in"
		enter-from-class="opacity-0 scale-50"
		enter-to-class="opacity-100 scale-100"
		leave-from-class="opacity-100 scale-100"
		leave-to-class="opacity-0 scale-75"
		appear
	>
		<div
			v-if="is_hotspot_visible && show"
			@click="openModal"
			class="hotspot-peg"
			:class="{ '-mt-[4%]': is_gallery_full_screen, 'card-hovered': card_hovered }"
			:style="peg_style"
			ref="peg_ref"
			role="button"
			:aria-label="`Open ${title} details`"
			tabindex="0"
			@keydown.enter="openModal"
			@keydown.space.prevent="openModal"
		>
			<div
				@mouseenter="handleMouseEnter"
				@mouseleave="handleMouseLeave"
				class="hotspot-interactive-area"
				:class="{ 'z-hotspot-hover': globally_active }"
			>
				<div 
					class="peg-dot group" 
					:class="portfolio_classes.container"
					@mouseenter="handleCardHover"
					@mouseleave="handleCardLeave"
				>
					<div class="peg-inner" :class="portfolio_classes.inner" />
					<div
						class="peg-ripple"
						:style="{ backgroundColor: portfolio_config.color }"
					/>
				</div>

				<Transition
					name="label"
					enter-active-class="transition-all duration-300 ease-[cubic-bezier(0.34,1.2,0.64,1)]"
					leave-active-class="transition-all duration-200 ease-in"
					enter-from-class="opacity-0 scale-90 translate-y-2"
					enter-to-class="opacity-100 scale-100 translate-y-0"
					leave-from-class="opacity-100 scale-100 translate-y-0"
					leave-to-class="opacity-0 scale-95 translate-y-1"
				>
					<div 
						v-if="shouldShowSuperMarker" 
						class="supermarker-label-container"
						@mouseenter="handleCardHover"
						@mouseleave="handleCardLeave"
					>
						<div class="supermarker-card">
							<div
								class="relative mb-2 w-full h-20 lg:h-28 rounded-lg overflow-hidden flex items-center justify-end"
							>
								<img
									:src="thumbnail_src"
									:alt="`${title} thumbnail`"
									class="w-full h-full object-cover rounded-lg absolute inset-0"
									loading="lazy"
									@error="handleImageError"
								/>

								<div
									v-if="show_portfolio_icon"
									class="absolute top-1 right-1 z-10 flex items-center justify-center w-6 h-6 bg-white rounded-full shadow-md"
								>
									<img
										:src="portfolio_icon"
										:alt="`${active_portfolio_name} portfolio icon`"
										class="w-3 h-3"
										loading="lazy"
									/>
								</div>
							</div>

							<div class="px-1">
								<span
									class="text-[10px] font-bold text-slate-950 leading-tight block"
								>
									{{ title }}
								</span>
							</div>
						</div>

						<div
							class="absolute left-1/2 -translate-x-1/2 -bottom-2 w-0 h-0 border-l-6 border-r-6 border-t-6 border-l-transparent border-r-transparent border-t-white"
						/>
					</div>
				</Transition>

				<Transition
					name="label"
					enter-active-class="transition-all duration-300 ease-[cubic-bezier(0.34,1.2,0.64,1)]"
					leave-active-class="transition-all duration-200 ease-in"
					enter-from-class="opacity-0 scale-90 translate-y-2"
					enter-to-class="opacity-100 scale-100 translate-y-0"
					leave-from-class="opacity-100 scale-100 translate-y-0"
					leave-to-class="opacity-0 scale-95 translate-y-1"
				>
					<div v-if="shouldShowLabel" class="peg-label-container">
						<div class="peg-label" v-text="title" />
						<div class="label-arrow" />
					</div>
				</Transition>
			</div>
		</div>
	</Transition>
</template>

<script src="./PegComponent.js"></script>
